import * as React from 'react';

import { HeroLayout } from '../../layouts/HeroLayout/HeroLayout';
import { Divider } from '../Divider/Divider';
import { ButtonListSection } from '../ButtonListSection/ButtonListSection';
import { HeroAuthors } from '../HeroAuthors/HeroAuthors';
import { BlogPostHeroTranslations } from './components/BlogPostHeroTranslations/BlogPostHeroTranslations';

import * as cs from './BlogPostHero.module.css';

interface Props {
  snippet: CustomTypes.BlogPostSnippet;
  authors: readonly Queries.authorFieldsFragment[];
  title: string;
  tags: CustomTypes.Tags;
  coverImage?: Queries.BlogPostPageEntryFragment['coverImage'];
  coverVideo?: Queries.BlogPostPageEntryFragment['coverVideo'];
  coverVideoLoop?: boolean | null;
  bgImages?: {
    default: Queries.BlogPostPageEntryFragment['bgImage'];
    original: {
      desktop: Queries.BlogPostPageEntryFragment['bgImageOriginal'];
      mobile: Queries.BlogPostPageEntryFragment['bgImageMobileOriginal'];
    };
  };
  isBgFullSize?: boolean | null;
  bgColorOverflow?: boolean | null;
  date: string;
  dateISO: string;
  translations: Queries.BlogPostPageEntryFragment['translations'];
  whiteBg: boolean;
  description?: string;
  opensourceProjects?: Queries.opensourceProjectFancyListFieldsFragment[];
}

export const BlogPostHero = ({
  authors,
  date,
  dateISO,
  title,
  coverImage,
  coverVideo,
  coverVideoLoop,
  bgImages,
  isBgFullSize,
  bgColorOverflow,
  translations,
  whiteBg,
  snippet,
  tags,
}: Props) => {
  const footer = !translations.length ? null : (
    <>
      <Divider />

      <div className={cs.translations}>
        <BlogPostHeroTranslations entries={translations} />
      </div>
    </>
  );

  return (
    <HeroLayout
      bgImages={bgImages}
      isBgFullSize={isBgFullSize}
      bgColorOverflow={bgColorOverflow}
      coverImage={coverImage}
      coverVideo={coverVideo}
      coverVideoLoop={coverVideoLoop}
      date={date}
      dateISO={dateISO}
      title={title}
      whiteBg={whiteBg}
      infoStart={
        !isBgFullSize && (
          <ButtonListSection entries={tags} title={snippet.topics} />
        )
      }
      infoEnd={<HeroAuthors entries={authors} />}
      footer={footer}
    />
  );
};
